import { render } from "./AutoUpdates.vue?vue&type=template&id=3179f8b0&scoped=true"
import script from "./AutoUpdates.vue?vue&type=script&lang=js"
export * from "./AutoUpdates.vue?vue&type=script&lang=js"

import "./AutoUpdates.vue?vue&type=style&index=0&id=3179f8b0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3179f8b0"]])

export default __exports__